import { ContractUt } from '@core/models/contract-ut.model';

export interface JsonContractUser {
  id: string;
  contractId: number;
  user: ContractUt;
  isActive: number;
  createdAt: Date;
  updatedAt: string;
}

export class ContractUser {
  id: string;
  contractId: number;
  user: ContractUt;
  isActive: number;
  createdAt: Date;
  updatedAt: string;

  constructor(jsonContractUser: JsonContractUser = null) {
    if (jsonContractUser) {
      this.id = jsonContractUser.id;
      this.contractId = jsonContractUser.contractId;
      this.user = jsonContractUser.user;
      this.isActive = jsonContractUser.isActive;
      this.createdAt = jsonContractUser.createdAt;
      this.updatedAt = jsonContractUser.updatedAt;
    }
  }
}
